import { WeatherService } from '../../weather/weather/weather.service';
import { LatLon } from '../../util/geodesy/latlon';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { MatDialog } from '@angular/material';
import { WeatherLegendComponent } from '../../shared/weather-legend/weather-legend.component';
var MetarSectionComponent = /** @class */ (function () {
    function MetarSectionComponent(_wx, _dialog) {
        this._wx = _wx;
        this._dialog = _dialog;
        this._clsWxSection = true;
    }
    Object.defineProperty(MetarSectionComponent.prototype, "latlon", {
        /**
         * Returns the latlon of the primary station identifier
         */
        get: function () {
            return this._latlon;
        },
        /**
         * Sets the lat/lon to be used as the center point when querying METARs. This is required (all METAR data, including
         * for the primary identifier, is loaded by lat/lon).
         */
        set: function (value) {
            if (this._latlon !== value) {
                this._latlon = value;
                this._load();
            }
        },
        enumerable: true,
        configurable: true
    });
    MetarSectionComponent.prototype._load = function () {
        this.metarPromise = new StatefulPromise(this._wx.getMetarsByLatLon(this._latlon));
    };
    Object.defineProperty(MetarSectionComponent.prototype, "_metars", {
        get: function () {
            if (!this.metarPromise || this.metarPromise.state !== PromiseState.Fulfilled) {
                return null;
            }
            return this.metarPromise.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetarSectionComponent.prototype, "primaryMetar", {
        /**
         * Returns the primary METAR
         * @returns {Metar}
         */
        get: function () {
            var _this = this;
            // this selects the METAR for the current airport, if there is one
            // it intentionally checks again after prepending a K to the identifier to account for fake ICAO ADDS airports (like M91)
            var tempMetar = null;
            if (this._metars) {
                tempMetar = this._metars.find(function (metar) { return metar.stationId === _this.identifier; });
                if (!tempMetar) {
                    tempMetar = this._metars.find(function (metar) { return metar.stationId === 'K' + _this.identifier; });
                }
            }
            return tempMetar;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetarSectionComponent.prototype, "nearbyMetars", {
        /**
         * Returns nearby METARs (excluding the primary METAR)
         * @returns {Array<Metar>}
         */
        get: function () {
            var _this = this;
            // this returns the nearby METARs by filtering out a local METAR, if there is one
            // it intentionally checks twice prepending a K to the identifier the second time to account for fake ICAO ADDS airports (like M91)
            return (this._metars || []).filter(function (metar) { return metar.stationId !== _this.identifier && metar.stationId !== 'K' + _this.identifier; });
        },
        enumerable: true,
        configurable: true
    });
    MetarSectionComponent.prototype.openWeatherLegend = function () {
        var dialogRef = this._dialog.open(WeatherLegendComponent, {
        // height: '500px'
        });
    };
    return MetarSectionComponent;
}());
export { MetarSectionComponent };
